// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-tour-template-js": () => import("../src/templates/TourTemplate.js" /* webpackChunkName: "component---src-templates-tour-template-js" */),
  "component---src-templates-blog-template-js": () => import("../src/templates/BlogTemplate.js" /* webpackChunkName: "component---src-templates-blog-template-js" */),
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blog-js": () => import("../src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-contact-js": () => import("../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tours-js": () => import("../src/pages/tours.js" /* webpackChunkName: "component---src-pages-tours-js" */)
}

